module.exports = __webpack_public_path__ + "static/media/IconGrayIndicator.ffae0cc3.svg";